import { render } from "./SetNickName.vue?vue&type=template&id=0ca81913&scoped=true&ts=true"
import script from "./SetNickName.vue?vue&type=script&setup=true&lang=ts"
export * from "./SetNickName.vue?vue&type=script&setup=true&lang=ts"

import "./SetNickName.vue?vue&type=style&index=0&id=0ca81913&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca81913"],['__file',"src/views/me/SetNickName.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ca81913"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ca81913', __exports__)) {
    console.log('reload')
    api.reload('0ca81913', __exports__)
  }
  
  module.hot.accept("./SetNickName.vue?vue&type=template&id=0ca81913&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('0ca81913', render)
  })

}


export default __exports__